<template>
  <div>
    <b-card class="mt-2">
      <!-- Search Filter -->
      <b-row class="mt-4">
        <b-col col="12">
          <SearchFilter
            @handleSubmit="onHandleSubmit"
            :autoSearch="true"
            :dashboardName="dashboardName"
          />
        </b-col>
      </b-row>

      <!-- BOX CHART -->
      <b-row>
        <b-col col="12" md="6">
          <div class="card box-main mt-2">
            <div
              class="card-body box-sub text-center"
              @click="
                openModal(
                  'จำนวนผู้ใช้งานทั้งหมด (ผู้รัมมอบอำนาจภายใต้ผู้ประกอบการทั้งหมด)',
                  'ATTORNEY_UNDER_MOU_COMPANY',
                )
              "
            >
              <h2 class="">{{ totalAttorneyUnderMouCompany }}</h2>
              <span class="card-title box-text-size">
                จำนวนผู้ใช้งานทั้งหมด (ผู้รัมมอบอำนาจภายใต้ผู้ประกอบการทั้งหมด)
              </span>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="card box-main mt-2">
            <div
              class="card-body box-sub text-center"
              @click="openModal('จำนวน Feedback', 'FEEDBACK')"
            >
              <h2 class="">{{ totalFeedback }}</h2>
              <span class="card-title box-text-size">
                จำนวน Feedback
              </span>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- BAR CHART -->
      <b-row class="mt-2">
        <b-col cols="12" lg="6" class="mb-3 mb-lg-0">
          <ApexDataBarChart
            ref="REF_BAR_FASTTRACK_TRANSACTION_USER"
            :filter="filter"
            :issueName="'FASTTRACK_TRANSACTION_USER'"
            :titleText="'แสดงจำนวนผู้เข้าใช้งานระบบ Fast Track (รายวัน)'"
          >
          </ApexDataBarChart>
        </b-col>
        <b-col cols="12" lg="6">
          <ApexDataBarStackChart
            ref="REF_BAR_FASTTRACK_SEND_RECIEVE_FROM_COMPANY"
            :filter="filter"
            :issueName="'FASTTRACK_SEND_RECIEVE_FROM_COMPANY'"
            :titleText="
              'แสดงจำนวนครั้งที่รับ-ส่ง เรื่องร้องทุกข์ระหว่างสคบกับผู้ประกอบการ (รายวัน)'
            "
          >
          </ApexDataBarStackChart>
        </b-col>
      </b-row>

      <!-- TABLE -->
      <b-row class="mt-2">
        <!-- TABLE LEFT -->
        <b-col cols="12" lg="6">
          <div class="card mt-2">
            <div class="card-body">
              <h5 class="mb-2">{{ tableLeftTitle }}</h5>
              <b-table
                striped
                hover
                small
                responsive
                :items="tableLeftItems"
                :fields="tableFields"
              ></b-table>
            </div>
          </div>
        </b-col>
        <!-- TABLE RIGHT -->
        <b-col cols="12" lg="6">
          <div class="card mt-2">
            <div class="card-body">
              <h5 class="mb-2">{{ tableRightTitle }}</h5>
              <b-table
                striped
                hover
                small
                responsive
                :items="tableRightItems"
                :fields="tableFields"
              ></b-table>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- <ModalDashboardDetailsList
      @show="openModal"
      ref="REF_MODAL_DASHBOARD_DETAILS_LIST"
      :filter="filter"
    ></ModalDashboardDetailsList> -->
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BCard,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BTable,
} from "bootstrap-vue";

// import flatPickr from "vue-flatpickr-component";
import ApexPieChart from "./components/charts/ApexPieChart.vue";
import ApexLineChart from "./components/charts/ApexLineChart.vue";
import ApexDataBarChart from "./components/charts/ApexDataBarChart.vue";
import ApexDataBarStackChart from "./components/charts/ApexDataBarStackChart.vue";
import SearchFilter from "./components/SearchFilter.vue";

import * as userData from "@/auth/localStorageUtils.js";
import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as apiUser from "@/store/api/user/index.js";

// import ModalDashboardDetailsList from "@/views/dashboard-complaint/components/ModalDashboardDetailsList.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BCardText,
    BTable,
    ApexPieChart,
    ApexLineChart,
    SearchFilter,
    ApexDataBarChart,
    ApexDataBarStackChart,
    // ModalDashboardDetailsList,
  },
  props: {},
  data() {
    return {
      totalAttorneyUnderMouCompany: 0,
      totalFeedback: 0,
      // TABLE (PLACEHOLDER DATA - WAITING FOR API)
      tableFields: [
        { key: "name", label: "หัวข้อ" },
        { key: "total", label: "จำนวน", class: "text-right" },
      ],
      tableLeftTitle: "รายชื่อบริษัทที่เข้าร่วม OCPB Fasttrack พร้อมจำนวนเรื่อง",
      tableLeftItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      tableRightTitle: "รายการสถานะดำเนินการจากระบบ OCPB Fasttrack",
      tableRightItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      filter: {
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: userData.userId(),
        departmentId: userData.departmentId(),
        terminateMode: "officer",
      },
      // dashboardName: `ภาพรวมสถิติการดำเนินการเรื่องร้องทุกข์ของเจ้าหน้าที่ ${userData.fullName()}`,
      dashboardName: `แสดงข้อมูลสรุปผลการดำเนินงานระบบ Fast Track`,
    };
  },
  mounted() {
    // BOXCHART
    this.funcGetSummaryFasttrackAttorneyUnderMouCompany();
    this.funcGetSummaryFeedback();

    this.TableChartComplaintFromOCPB();
    this.TableChartComplaintStatusOverview();
  },
  methods: {
    onHandleSubmit(submitFilter) {
      const self = this;

      self.filter.startDate = submitFilter.startDate;
      self.filter.endDate = submitFilter.endDate;

      // BOXCHART
      self.funcGetSummaryFasttrackAttorneyUnderMouCompany();
      self.funcGetSummaryFeedback();

      // SEARCH FILTER TRIGGER BY $REFS
      self.$refs.REF_BAR_FASTTRACK_TRANSACTION_USER.funcGetBarChart_SummaryFasttrackTransactionUser(
        self.filter,
      );
      self.$refs.REF_BAR_FASTTRACK_SEND_RECIEVE_FROM_COMPANY.funcGetSummaryFasttrackSendToAndRecieveFromCompany(
        self.filter,
      );

      self.TableChartComplaintFromOCPB(self.filter);
      self.TableChartComplaintStatusOverview(self.filter);
    },
    funcGetUser() {
      const self = this;
      const isAdmin = userData.isAdminRole();
      if (isAdmin === true) {
        // //console.log"@funcGetUser isAdmin", isAdmin);
        apiUser
          .getById(self.filter.userId)
          .then((response) => {
            // //console.log"@funcGetUser response", response);
            if (response.data.data.fullname) {
              self.dashboardName = `${self.dashboardName} ${response.data.data.fullname}`;
            }
          })
          .catch((error) => {
            //console.log"error", error);
          });
        //console.log"@funcGetUser self.dashboardName", self.dashboardName);
      } else {
        self.dashboardName = `${self.dashboardName} ${userData.fullName()}`;
        //console.log"@funcGetUser self.dashboardName", self.dashboardName);
      }
    },
    funcGetSummaryFasttrackAttorneyUnderMouCompany() {
      console.log("start fasttrack attorneys under mou company");
      const self = this;
      apiDashboard
        .GetBoxChart_SummaryFasttrackAttorneyUnderMouCompany(self.filter)
        .then((response) => {
          console.log("data fasttrack attorneys under mou company", response);
          self.totalAttorneyUnderMouCompany = response.data.data;
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    funcGetSummaryFeedback() {
      const self = this;
      // apiDashboard
      //   .GetBoxChart_SummaryComplaintTerminate(self.filter)
      //   .then((response) => {
      //     self.totalComplaintTerminate = response.data.data;
      //   })
      //   .catch((error) => {
      //     //console.log"error", error);
      //   });
    },
    TableChartComplaintFromOCPB() {
      apiDashboard
        .TableChartComplaintFromOCPB(this.filter)
        .then((response) => {
          console.log("TableChartComplaintFromOCPB .response", response);
          console.log("TableChartComplaintFromOCPB .response.data", response.data);

          this.tableLeftItems = response.data.data.map((item) => ({
            name: item.name,
            total: item.total,
          }));

          console.log("TableChartComplaintFromOCPB .tableLeftItems", this.tableLeftItems);
        })
        .catch((error) => {
          console.log("TableChartComplaintFromOCPB .error", error);
        });
    },
    TableChartComplaintStatusOverview() {
      apiDashboard
        .TableChartComplaintStatusOverview(this.filter)
        .then((response) => {
          console.log("TableChartComplaintStatusOverview .response", response);
          console.log("TableChartComplaintStatusOverview .response.data", response.data);

          this.tableRightItems = response.data.data.map((item) => ({
            name: item.name,
            total: item.total,
          }));

          console.log("TableChartComplaintStatusOverview .tableRightItems", this.tableRightItems);
        })
        .catch((error) => {
          console.log("TableChartComplaintStatusOverview .error", error);
        });
    },
    openModal(title, keyword) {
      console.log("MODAL ACTIVE");
      // const _modal = this.$refs["REF_MODAL_DASHBOARD_DETAILS_LIST"];

      // _modal.onSetData(title, keyword, this.filter); // send object to child
      // _modal.$refs["REF_MODAL_DASHBOARD_DETAILS"].show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.box-main {
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  height: 150px;
  border-top-style: solid;
  border-top-color: #bfb9f1;
  border-top-width: 20px;
  border-radius: 0;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.box-main:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  background-color: #f8f9fa; /* light gray highlight */
  border-top-color: red;
}
.box-sub {
  background-color: #f8f9fa;
  // background-color: whitesmoke;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.box-text-size {
  font-size: 16px !important;
}

.card-underline {
  // border-bottom-style: solid;
  border-bottom-color: black;
}

// .dashboard-card {
//   max-height: 100vh;
//   display: flex;
//   flex-direction: column;
// }

// .dashboard-scroll {
//   overflow-y: auto;
//   flex: 1;
//   padding-top: 0.5rem;
// }
</style>
